"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(max, fileName) {
    const splitted = fileName.split('.');
    const splittedLength = splitted.length;
    const extension = splittedLength > 1 ? `.${splitted.pop()}` : '';
    const name = splittedLength > 2 ? splitted.join('.') : splitted.pop();
    if (!!name && name.length > max) {
        return name.slice(0, max) + '...' + extension;
    }
    else
        return fileName;
}
exports.default = default_1;
